import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Indicator, UnstyledButton } from '@mantine/core';
import { NavLink, useNavigate } from 'react-router-dom';
import styles from './style.module.css';

const NavbarLink = (
  {
    icon: Icon, label, to, onClick, expanded, badge,
  },
) => {
  const navLinkClasses = ({ isActive }) => clsx(styles.link, isActive && styles.active);
  const navigate = useNavigate();
  const handleButtonClick = (e) => {
    e.preventDefault();
    onClick();
  };

  const handleLabelClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  const iconEl = badge > 0 ? (
    <Indicator label={badge} size={18} color="red" position="top-start" className={styles.indicator}>
      <Icon />
    </Indicator>
  ) : <Icon />;

  return (
    <>
      {onClick ? (
        <>
          <div className={styles.container}>
            <UnstyledButton className={styles.link} onClick={handleButtonClick}>
              {iconEl}
            </UnstyledButton>
            {expanded && <span className={styles.label} onClick={handleButtonClick}>{label}</span>}
          </div>
        </>
      ) : (
        <div className={styles.container}>
          <NavLink to={to} className={navLinkClasses}>
            {iconEl}
          </NavLink>
          {expanded && <span className={styles.label} onClick={handleLabelClick}>{label}</span>}
        </div>
      )}
    </>
  );
};

NavbarLink.propTypes = {
  icon: PropTypes.any,
  label: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  expanded: PropTypes.bool,
  badge: PropTypes.number,
};

NavbarLink.defaultProps = {
  badge: 0,
};

export default NavbarLink;
